enum PaymentReceiptInfo {
  OBLAT = 'OBLAT',
  PRINT = 'PRINT',
  NONE = 'NONE',
}

export default PaymentReceiptInfo;
